import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetListComponent } from './widget-list/widget-list.component';
import { WidgetDetailComponent } from './widget-detail/widget-detail.component';
import { WidgetService } from './widget.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MapEditorComponent } from './widget-detail/map-editor/map-editor.component';
import { RegionComponent } from './widget-detail/map-editor/region.component';
import { RegionPointComponent } from './widget-detail/map-editor/region-point.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SunstudioModalComponent } from './sunstudio-modal/sunstudio-modal.component';
import { SharedModule } from '../shared/shared/shared.module';
import { MapListComponent } from './widget-detail/map-list/map-list.component';
import { ChangeTemplateModalComponent } from './widget-detail/change-template-modal/change-template-modal.component';
import { EditWidgetModalComponent } from './edit-widget-modal/edit-widget-modal.component';
import { CreateMapModalComponent } from './widget-detail/create-map-modal/create-map-modal.component';
import { WidgetDetailSunstudiesComponent } from './widget-detail/widget-detail-sunstudies/widget-detail-sunstudies.component';
import { WidgetDetailMainComponent } from './widget-detail/widget-detail-main/widget-detail-main.component';
import { WidgetDetailPreviewComponent } from './widget-detail/widget-detail-preview/widget-detail-preview.component';
import { SunstudyViewFormComponent } from './sunstudio-modal/sunstudy-view-form/sunstudy-view-form.component';
import { SunstudyService } from './sunstudy.service';
import { WidgetMapService } from './widget-map.service';
import { RouterModule } from '@angular/router';
import { MoveMapModalComponent } from './move-map-modal/move-map-modal.component';
import { EditorMapListComponent } from './widget-detail/map-editor/editor-map-list/map-list.component';
import { EditorObjectListComponent } from './widget-detail/map-editor/editor-object-list/editor-object-list.component';
import { WidgetSettingComponent } from './edit-widget-modal/widget-setting/widget-setting.component';
import { WidgetSettingDirective } from './edit-widget-modal/widget-setting.directive';
import { WidgetDetailDashboardComponent } from './widget-detail/widget-detail-dashboard/widget-detail-dashboard.component';
import { EditMapModalComponent } from './widget-detail/edit-map-modal/edit-map-modal.component';
import { WidgetMapUploadComponent } from './widget-detail/widget-map-upload/widget-map-upload.component';
import { EditorObjectListItemComponent } from './widget-detail/map-editor/editor-object-list/editor-object-list-item/editor-object-list-item.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    // WidgetsRoutingModule,
    CommonModule,
    RouterModule,
    SharedModule,
    ReactiveFormsModule
  ],
  declarations: [
    WidgetListComponent,
    WidgetDetailComponent,
    MapEditorComponent,
    RegionComponent,
    RegionPointComponent,
    SunstudioModalComponent,
    MapListComponent,
    ChangeTemplateModalComponent,
    EditWidgetModalComponent,
    CreateMapModalComponent,
    WidgetDetailSunstudiesComponent,
    WidgetDetailMainComponent,
    WidgetDetailPreviewComponent,
    SunstudyViewFormComponent,
    MoveMapModalComponent,
    EditorMapListComponent,
    EditorObjectListComponent,
    WidgetSettingComponent,
    WidgetSettingDirective,
    WidgetDetailDashboardComponent,
    EditMapModalComponent,
    WidgetMapUploadComponent,
    EditorObjectListItemComponent
  ],
  providers: [
    WidgetService,
    SunstudyService,
    WidgetMapService
  ],
  entryComponents: [
    SunstudioModalComponent,
    EditWidgetModalComponent,
    ChangeTemplateModalComponent,
    CreateMapModalComponent,
    MoveMapModalComponent,
    EditMapModalComponent
  ]
})

export class WidgetsModule {
}



// WEBPACK FOOTER //
// ./src/app/widgets/widgets.module.ts